"use client";
import React from "react";
import LoanCard from "./card";
import Image from "next/image";
import { IMAGES } from "@/lib/constants";
import { Box, Stack, Typography } from "@mui/material";

const ActiveLoanCardList = ({ activeLoansData, isLoading }) => {
  return (
    <>
      {isLoading && <Typography variant="h5">Loading...</Typography>}
      {activeLoansData?.data?.myloans?.length > 0 && (
        <Stack gap={2}>
          <Stack direction={"row"} alignItems={"center"} spacing={2}>
            <Image src={IMAGES.leftWindow} alt="Hero" />
            <Typography variant="h5">My Loans</Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              p: 2,
              gap: 4,
            }}
          >
            {activeLoansData?.data?.myloans?.map((loan) => (
              <Box key={loan.appId} sx={{ flex: "0 0 auto", minWidth: 280 }}>
                <LoanCard {...loan} />
              </Box>
            ))}
          </Box>
        </Stack>
      )}
    </>
  );
};

export default ActiveLoanCardList;
